import { ReactElement } from 'react';
import { ProjectDetailsDatasetsContainer } from '../../../modules/projectDetails/containers/ProjectDetailsDatasets.container';

export const ProjectDetailsDatasetsView = (): ReactElement => <ProjectDetailsDatasetsContainer />;
